import Model from './Model';

export default class CostType extends Model {
    resource() {
        return 'cost-types';
    }
}
